module.exports = __webpack_public_path__ + "static/media/ad-demo.c2ad7b45.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/ad-demo.png
 ** module id = 173
 ** module chunks = 0
 **/